import { IFacepilePersona } from '@fluentui/react/lib/Facepile';
import { getInitials } from '@fluentui/react/lib/Utilities';

import { onRenderIcon } from '../Renderers';
import { CoauthorGalleryPalette, getPersonaCoinStyles } from '../Styles';

/**
 * After we convert the coauthorInformations into IFacepilePersonas in the convertCoauthor function. We need to further
 * convert the IFacepilePersona into an IPersonaShared object in order to add some customization to the persona coins.
 */
export const getPersonaProps = (coinSize: number, palette: CoauthorGalleryPalette, fallbackUserImage?: string) => {
  return (persona: IFacepilePersona) => {
    return {
      personaName: persona.name,
      onRenderInitials:
        (getInitials(persona.data.name, false) === '' || persona.data.isAnonymous) && fallbackUserImage
          ? onRenderIcon(coinSize, fallbackUserImage)
          : undefined,
      hidePersonaDetails: true, // Set to true or else facepile will render a full persona when only one coauthor is present
      initialsColor: persona.data.color, // Must specify initials color here because IFacepilePersona takes an enum of FacepilePersonaColors, but we can use a string here
      styles: { coin: getPersonaCoinStyles(palette, persona.data.color, persona.data.hasRing) },
      coinSize,
      title: '',
      showInitialsUntilImageLoads: true,
      coinProps: { styles: { coin: getPersonaCoinStyles(palette, persona.data.color, persona.data.hasRing) } },
    };
  };
};
